import { useState } from 'react';

type StateType = any[] | Record<string, any> | Map<any, any> | Set<any>;

function useMergedState<T extends StateType>(
  initialState: T,
): [T, (newState: Partial<T> | ((prevState: T) => Partial<T>)) => void] {
  const [state, setState] = useState<T>(initialState);

  const mergeState = (
    newState: Partial<T> | ((prevState: T) => Partial<T>),
  ) => {
    setState((prevState) => {
      const updatedState =
        typeof newState === 'function' ? newState(prevState) : newState;
      if (Array.isArray(prevState) && Array.isArray(updatedState)) {
        return [...prevState, ...updatedState] as T;
      } else if (prevState instanceof Map && updatedState instanceof Map) {
        return new Map([...prevState, ...updatedState]) as T;
      } else if (prevState instanceof Set && updatedState instanceof Set) {
        return new Set([...prevState, ...updatedState]) as T;
      } else if (
        typeof prevState === 'object' &&
        typeof updatedState === 'object'
      ) {
        return { ...prevState, ...updatedState } as T;
      } else {
        return updatedState as T;
      }
    });
  };

  return [state, mergeState];
}

export default useMergedState;
